import React from 'react';
import {PhoneProps as Props} from './Phone.type';
import {PhoneInput} from '@components/PhoneInput';

import cn from './Phone.module.scss';

export const Phone = React.forwardRef(function Phone(
  {className, value: inputValue, ...props}: Props,
  ref
) {
  const isvalid = (inputValue as string)?.length > 0;
  return (
    <>
      <PhoneInput
        ref={ref}
        {...props}
        className={`${isvalid ? cn.inputFilled : ''} ${className}`}
      />
    </>
  );
});
